import script from "./browse-artists.vue?vue&type=script&setup=true&lang=js"
export * from "./browse-artists.vue?vue&type=script&setup=true&lang=js"

import "./browse-artists.vue?vue&type=style&index=0&id=a4d80c22&lang=css"

const __exports__ = script;

export default __exports__